import Metrics from '../Metrics'

export enum Chart {
    Bars = 'bars',
    Doughnut = 'doughnut',
    List = 'list',
    Timeline = 'timeline',
}

export enum BoxSizes {
    BIG = 'big',
    FULLWIDTH = 'fullwidth',
    MID = 'mid',
    SIXTH = 'sixth',
    SMALL = 'small',
    THIRD = 'third',
}

export interface Metric {
    'box-size': string
    'count-data'?: string
    chart?: Chart
    color?: string | string[]
    count?: string
    icon?: string
    legend?: boolean
    link?: string
    title: string
    type: string
}

export interface MetricGroup {
    'box-size': BoxSizes
    metrics?: Metric[]
    type: Metrics.GROUP
}

export interface Dashboard {
    id: string
    name: string
    daterange: boolean
    metrics: Array<Metric | MetricGroup>
}
